import React, { useEffect, useState } from "react";
import "../../pages/analytics/analytics.css";
import "../../reusableComponents/modals/smallModal.css";
import {
  Dialog,
  DialogActions,
  IconButton,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import CustomButton from "../../reusableComponents/CustomButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useAuth } from "../../context/API_Client";
import { customToast } from "../../reusableComponents/customToaster/customToast";

const ProductSettingsModal = ({
  outlinedBtnText,
  filledBtnText,
  outlinedBtnFunction,
  toggleDialog,
  setToggalModal,
  type,
  filledBtnFunction,
}) => {
  const { merchantSettings, updateCheckoutSettings } = useAuth();
  const [settings, setSettings] = useState();
  const [version, setVersion] = useState();

  useEffect(() => {
    merchantSettings(
      (data) => {
        setSettings(data);
        setVersion(data?.version);
      },
      (errMsg) => {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  const handleSwitchChange = (settingKey) => (event) => {
    const newValue = event.target.checked;
    let payLoad = { ...settings };
    if ("version" in payLoad) delete payLoad["version"];
    payLoad[settingKey] = newValue;

    updateCheckoutSettings(
      { ...payLoad, version },
      (data) => {
        localStorage.setItem("merchantSettings", JSON.stringify(data));
        setSettings(data);
        setVersion(data?.version);
        customToast("success", "high", "Product setting updated successfully");
      },
      (errMsg) => {
        customToast("error", "high", errMsg);
      }
    );
  };

  return (
    <Dialog
      open={toggleDialog}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          borderRadius: "12px",
          width: "416px",
        },
      }}
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          outlinedBtnFunction();
        }
      }}
    >
      <div className="" style={{ padding: "24px 24px 0px 24px" }}>
        <div>
          <Typography
            className="bodyB1Medium"
            sx={{
              color: "var(--character-title-85, rgba(0, 0, 0, 0.85))",
              marginBottom: "8px",
            }}
          >
            Product Link Settings
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Typography className="setting-dropdown-item-typography">
              Product type mandatory
            </Typography>
            <Tooltip
              title="This setting will make Product Type mandatory for all the payment links created in the future"
              arrow
            >
              <IconButton
                sx={{
                  "&:hover": { backgroundColor: "transparent" },
                }}
                disableFocusRipple
                disableTouchRipple
              >
                <InfoOutlinedIcon
                  sx={{
                    height: "16px",
                    width: "16px",
                    border: "0px",
                    color: "#000000D9",
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>

          <Switch
            checked={settings?.requiresProductCode || false}
            onChange={handleSwitchChange("requiresProductCode")}
            sx={{
              "& .MuiSwitch-thumb": {
                boxShadow: "none",
                color: "#24B7AA",
              },
              "& .MuiSwitch-track": {
                backgroundColor: "#24B7AA",
              },
              "& .Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#24B7AA !important",
              },
              "& .Mui-checked .MuiSwitch-thumb": {
                color: "#24B7AA",
              },
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Typography className="setting-dropdown-item-typography">
              Notify via SMS
            </Typography>
            <Tooltip
              title="This setting will enable Notification Service via SMS for all the upcoming INR payment links created"
              arrow
            >
              <IconButton
                sx={{
                  "&:hover": { backgroundColor: "transparent" },
                }}
                disableFocusRipple
                disableTouchRipple
              >
                <InfoOutlinedIcon
                  sx={{
                    height: "16px",
                    width: "16px",
                    border: "0px",
                    color: "#000000D9",
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>
          <Switch
            checked={settings?.notifyViaSmsEnabled || false}
            onChange={handleSwitchChange("notifyViaSmsEnabled")}
            sx={{
              "& .MuiSwitch-thumb": {
                boxShadow: "none",
                color: "#24B7AA",
              },
              "& .MuiSwitch-track": {
                backgroundColor: "#24B7AA",
              },
              "& .Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#24B7AA !important",
              },
              "& .Mui-checked .MuiSwitch-thumb": {
                color: "#24B7AA",
              },
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Typography className="setting-dropdown-item-typography">
              Product description editable
            </Typography>
            <Tooltip
              title="This setting will make Product description editable for all the payment links created in the future"
              arrow
            >
              <IconButton
                sx={{
                  "&:hover": { backgroundColor: "transparent" },
                }}
                disableFocusRipple
                disableTouchRipple
              >
                <InfoOutlinedIcon
                  sx={{
                    height: "16px",
                    width: "16px",
                    border: "0px",
                    color: "#000000D9",
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>
          <Switch
            checked={settings?.editableProductDescription || false}
            onChange={handleSwitchChange("editableProductDescription")}
            sx={{
              "& .MuiSwitch-thumb": {
                boxShadow: "none",
                color: "#24B7AA",
              },
              "& .MuiSwitch-track": {
                backgroundColor: "#24B7AA",
              },
              "& .Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#24B7AA !important",
              },
              "& .Mui-checked .MuiSwitch-thumb": {
                color: "#24B7AA",
              },
            }}
          />
        </div>
      </div>

      <DialogActions
        className="modal-footer"
        sx={{
          border: "0px",
          display: "flex",
          boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
          marginTop: "12px",
        }}
      >
        {outlinedBtnText !== "" && (
          <CustomButton
            text={outlinedBtnText}
            variant={"outlined"}
            size={"xs"}
            type={type}
            onClick={outlinedBtnFunction}
          />
        )}
        {filledBtnText !== "" && (
          <CustomButton
            text={filledBtnText}
            variant={"contained"}
            size={"xs"}
            type={type}
            onClick={() => filledBtnFunction()}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

ProductSettingsModal.defaultProps = {
  headerText: "Info",
  subHeaderText: "sub header text goes here",
  icon: <img src="/assets/orderDetailsIcons/ExclamationCircle-yellow.svg" />,
  outlinedBtnText: "",
  filledBtnText: "",
  outlinedBtnFunction: () => {},
  filledBtnFunction: () => {},
  toggleDialog: false,
  type: "secondary",
  dropdownData: null,
};

export default ProductSettingsModal;
